/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from "~/core";
setup();

import "~/global/_body";
import "~/global/_header";
import "~/global/_footer";
import "~/global/_alert";
import "~/global/_searchModal";

import "~/components/_accordion";
import "~/components/_forms";
import "~/components/_heroHome";
import "~/components/_carousel";
import "~/components/_ctaUpdates";
import "~/components/_faqs";
import "~/components/_intNav";
import "~/components/_video";
import "~/components/_eventDetails";
import "~/components/_modal";
